import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { formatPrice } from 'common/helpers'

import s from './UpchargePrice.scss'


const UpchargePrice = ({ className, price = 0, large, small }) => {
  const rootClassName = cx(s.container, className, {
    [s.large]: large,
    [s.small]: small,
  })

  const upchargePrice = `+${formatPrice(price, true, true, 0)}`

  return (
    <span className={rootClassName} data-testid="upchargePrice">
      {upchargePrice}
    </span>
  )
}

UpchargePrice.propTypes = {
  className: PropTypes.string,
  price: PropTypes.number,
  large: PropTypes.bool,
  small: PropTypes.bool,
}


export default React.memo(UpchargePrice)
